import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const API = '/api/tikoo/auth';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/forgot-password`, { email });
      setSent(true);
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const bg = { minHeight: '100vh', background: 'linear-gradient(135deg,#1A2744,#2D3A5F)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 };

  return (
    <div style={bg}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="https://omogusiiwarriors.org/icons/logo.png" alt="OWW" style={{ width: 70, height: 70, objectFit: 'contain', marginBottom: 12 }} />
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: '#fff', margin: '0 0 4px' }}>Tikoo Organizer</h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, marginTop: 4 }}>Password Recovery</p>
        </div>
        <div style={{ background: '#fff', borderRadius: 20, padding: 40, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          {!sent ? (
            <>
              <h2 style={{ fontSize: 20, marginBottom: 6, color: '#1A2744' }}>Forgot Password?</h2>
              <p style={{ color: '#9CA3AF', fontSize: 14, marginBottom: 24 }}>Enter your organizer email and we'll send you a reset link.</p>
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Email Address</label>
                  <input
                    type="email"
                    placeholder="your@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    style={{ width: '100%', padding: '12px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 15, boxSizing: 'border-box' }}
                  />
                </div>
                <button type="submit" disabled={loading}
                  style={{ width: '100%', background: '#E8521A', color: '#fff', padding: 14, borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 16, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
                  {loading ? '⏳ Sending...' : '📧 Send Reset Link'}
                </button>
              </form>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 64, marginBottom: 16 }}>📬</div>
              <h2 style={{ fontSize: 20, marginBottom: 12, color: '#1A2744' }}>Check Your Email</h2>
              <p style={{ color: '#6B7280', marginBottom: 8 }}>If <strong>{email}</strong> is registered, you'll receive a reset link shortly.</p>
              <p style={{ color: '#9CA3AF', fontSize: 13, marginBottom: 24 }}>Don't forget to check your spam folder.</p>
              <button onClick={() => setSent(false)} style={{ width: '100%', background: 'transparent', border: '1px solid #E5E7EB', borderRadius: 8, padding: '10px 0', fontWeight: 600, cursor: 'pointer' }}>
                Try a different email
              </button>
            </div>
          )}
          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#6B7280' }}>
            Remember it? <Link to="/organizer/login" style={{ color: '#E8521A', fontWeight: 600 }}>Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
